import { createSlice } from '@reduxjs/toolkit';
import ApplicationAlert, { AlertType } from '../../common/domain/ApplicationAlert';
import * as reducers from './reducers';

export interface AlertsState {
  alerts: Array<ApplicationAlert>;
}

const testState = [
    {
        type:AlertType.UPLOAD,
        body:'Upload complete',
        header:'Upload complete',
        groupId: 'TCA_DEV_DATA_HSBC_EUDESK',
        ingestId: '76890be3-000e-4647-99b4-e84e5656c309',
        loading: false
    }
  ];

const initialState: AlertsState = {
  alerts: [],
};

export default createSlice({ name: 'alerts', initialState, reducers });
